import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.LeaseMoveOutPolicy1,
  LocationVarKey.LeaseMoveOutPolicy2,
  LocationVarKey.LeaseMoveOutPolicy3
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Move Out Policy
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeaseMoveOutPolicy1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.LeaseMoveOutPolicy2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.LeaseMoveOutPolicy3}
        enableSwitchVar={LocationVarKey.LeaseMoveOutPolicy3Enabled}
      />
    </>
  );
}
